import { css } from "styled-components";
import token from "styled-token";
import { ORIENTATIONS } from "../../constants/ORIENTATIONS";
import { marginMixin } from "../marginMixin";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";

var appearanceCSS = function appearanceCSS(props) {
  return token("Divider." + props.appearance + ".backgroundColor", function (backgroundColor) {
    return css(["background-color:", ";"], backgroundColor);
  })(props);
};

var lengthCSS = function lengthCSS(props) {
  return token("Divider.lengths." + props.length, function (length) {
    var value = typeof length === "number" ? length + "px" : length;
    return css(["height:", ";width:", ";"], value, value);
  })(props);
};

var orientationCSS = function orientationCSS(props) {
  return token("Divider." + props.appearance + ".thickness", function (thickness) {
    return props.orientation === ORIENTATIONS.horizontal ? css(["height:", "px;"], thickness) : css(["width:", "px;"], thickness);
  })(props);
};
/** @class DividerMixin */

/** @method */


export var DividerMixin = function DividerMixin(props) {
  return css(["", " ", " ", " ", ""], appearanceCSS(props), inlineMediaQueryMixin("length", lengthCSS)(props), inlineMediaQueryMixin("orientation", orientationCSS)(props), marginMixin(Object.assign({}, props)));
};